export default {"src":"/_next/static/media/customer_support.1f585ddb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};